import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  justify-content: center;
`;
Container.displayName = 'Container';

export const CoinContainer = styled.div`
  height: 150px;
  position: relative;
  width: 150px;
`;
CoinContainer.displayName = 'CoinContainer';

export const CoinInside = styled.div`
  border-radius: 100%;
  height: 150px;
  position: relative;
  transform-style: preserve-3d;
  width: 150px;
`;
CoinInside.displayName = 'CoinInside';

export const Coin = styled.div`
  backface-visibility: hidden;
  position: absolute;

  &.heads {
    transform: rotateY(0deg);
  }

  &.tails {
    transform: rotateY(180deg);
  }
`;
Coin.displayName = 'Coin';
